import React from 'react';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import { translate as t } from 'hooks/useTranslations';

const RuleConfiguration: React.FC = () => {
  return (
    <TakeoverLayout
      pageTitle={t('performanceReporting.eis.configuration.pageTitle')}
      backUrl='..'
    >
      {/* Placeholder: content to be added in VAL-1228 */}
    </TakeoverLayout>
  );
};

export default RuleConfiguration;
